
import { defineComponent, PropType } from 'vue'

import IntegrationsDetailMixin from '~/mixins/integrationsDetailMixin'
import OwnerDetailMixin from '~/mixins/ownerDetailMixin'
import RepoDetailMixin from '~/mixins/repoDetailMixin'
import { IntegrationProvider } from '~/types/types'

export default defineComponent({
  name: 'NotificationChannelSection',
  mixins: [IntegrationsDetailMixin, OwnerDetailMixin, RepoDetailMixin],
  model: {
    prop: 'channel',
    event: 'change'
  },
  props: {
    channel: {
      type: String,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    },
    availableChannels: {
      type: Array as PropType<Array<IntegrationProvider>>,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.channel
      },
      set(value: string) {
        this.$emit('change', value)
      }
    },
    hasChannelList(): boolean {
      if (!this.pending) {
        return (
          Boolean(this.integration.options?.channel?.length) ||
          Boolean(this.availableChannels?.length)
        )
      }
      return false
    },
    placeholder(): string {
      // Set the placeholder text as the model value only if the channel list is available
      if (this.modelValue && this.hasChannelList) {
        return this.modelValue
      }

      return this.integration.installed
        ? this.hasChannelList
          ? 'Select a channel'
          : 'No channels found'
        : 'Connect Slack'
    },

    channelList(): string[] {
      // Fallback to the channel list supplied via `availableChannels` prop
      return this.integration.options?.channel || this.availableChannels || []
    }
  }
})
